import React from 'react';

export const DragDropSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="45"
    height="46"
    viewBox="0 0 45 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5028_54031)">
      <path
        d="M11.7179 35.2464C8.71613 35.2464 6.04605 33.3244 5.07648 30.4631L5.0109 30.2475C4.78224 29.4897 4.68645 28.8525 4.68645 28.2149V15.4307L0.137659 30.6148C-0.447377 32.8482 0.885778 35.1636 3.12258 35.7806L32.1166 43.5454C32.4784 43.6391 32.8403 43.6841 33.1967 43.6841C35.0641 43.6841 36.7704 42.4446 37.2487 40.6181L38.9379 35.2464H11.7179Z"
        fill="currentColor"
      />
      <path
        d="M16.8742 15.558C18.9425 15.558 20.6241 13.8761 20.6241 11.8078C20.6241 9.7396 18.9425 8.05762 16.8742 8.05762C14.806 8.05762 13.124 9.7396 13.124 11.8078C13.124 13.8761 14.806 15.558 16.8742 15.558Z"
        fill="currentColor"
      />
      <path
        d="M40.3122 2.43262H12.1865C9.60296 2.43262 7.49902 4.53655 7.49902 7.12046V27.7457C7.49902 30.3296 9.60296 32.4336 12.1865 32.4336H40.3122C42.8961 32.4336 45.0001 30.3296 45.0001 27.7457V7.12046C45.0001 4.53655 42.8961 2.43262 40.3122 2.43262V2.43262ZM12.1865 6.18282H40.3122C40.83 6.18282 41.2499 6.60272 41.2499 7.12046V20.4314L35.3267 13.5198C34.6984 12.783 33.7889 12.3892 32.8121 12.3669C31.8409 12.3724 30.9297 12.8036 30.3072 13.55L23.3431 21.9088L21.0743 19.6455C19.792 18.3632 17.7049 18.3632 16.4243 19.6455L11.2492 24.8188V7.12046C11.2492 6.60272 11.6691 6.18282 12.1865 6.18282V6.18282Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default DragDropSvg;
